import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../common/dialog/BootstrapDialog';

import { unloadOrder, viewOrder } from '../../modules/projectModule/order';
import ApprovalFormContainer from '../../containers/approvalmng/ApprovalFormContainer';
import DetailTemplate from '../common/template/DetailTemplate';
import ApprovalSummary from '../approval/ApprovalSummary';
import OrderBookInfoContainer from '../../containers/projectmng/obtainorder/OrderBookInfoContainer';
import SalesProfitInfoContainer from '../../containers/projectmng/obtainorder/SalesProfitInfoContainer';
import OrderBookApprovalContainer from '../../containers/projectmng/obtainorder/OrderBookApprovalContainer';
import OrderProductListContainer from '../../containers/projectmng/obtainorder/OrderProductListContainer';
import {
  unloadProject,
  viewProject,
} from '../../modules/projectModule/project';

const OrderViewModal = ({ open, handleClose, id }) => {
  const dispatch = useDispatch();
  const { project, user, receiveOrderInf, approvalList, loading } = useSelector(
    ({ auth, projectModule, userModule, loading }) => ({
      user: auth.user,
      project: projectModule.project.project,
      receiveOrderInf: projectModule.order.receiveOrderInf,
      billInfList: projectModule.order.billInfList,
      billInvList: projectModule.order.billInvList,
      approvalList: projectModule.order.approvalList,
      message: projectModule.order.message,
      error: projectModule.order.error,
      loading: loading['project/VIEW_ORDER'],
    }),
  );

  useEffect(() => {
    if (id) {
      dispatch(viewOrder(id));
    }

    return () => {
      unloadOrder();
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (receiveOrderInf) {
      dispatch(viewProject(receiveOrderInf?.prjUuid));
    }
  }, [dispatch, receiveOrderInf]);

  if (loading || !receiveOrderInf || !project) {
    return null;
  }

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      fullScreen
      fullWidth={true}
    >
      <BootstrapDialogTitle onClose={handleClose}>
        수주품의서 상세 내역
      </BootstrapDialogTitle>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DialogContent
          dividers
          sx={{
            height: 600,
            overflowY: 'auto',
          }}
        >
          {receiveOrderInf && receiveOrderInf?.ordYn === 'S' && (
            <ApprovalFormContainer
              docuCd={receiveOrderInf?.roUuid}
              user={user}
              type="order"
            />
          )}

          <DetailTemplate title="상세내역">
            <OrderBookInfoContainer orderInfo={receiveOrderInf} />
          </DetailTemplate>

          <DetailTemplate title="최종 매출 이익 (내부거래 포함)">
            <SalesProfitInfoContainer
              orderInfo={receiveOrderInf}
              project={project}
            />
          </DetailTemplate>

          <DetailTemplate title="결재 내역">
            <OrderBookApprovalContainer approvalList={approvalList} />
          </DetailTemplate>

          <DetailTemplate title="원가산출내역">
            <OrderProductListContainer />
          </DetailTemplate>
        </DialogContent>
        <DialogActions></DialogActions>
      </Box>
    </BootstrapDialog>
  );
};

export default OrderViewModal;
